import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  cardMedia: {
    height: 122,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',

    '& img': {
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  cardMediaBadge: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),

    '& > *': {
      display: 'inline-block',
      padding: 4,
      marginLeft: theme.spacing(1),
      color: theme.palette.grey[700],
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.common.white,
      boxShadow: theme.shadows[1],
      marginTop: 84,
      marginRight: -5,
    },
  },
}));
